import React from 'react';

interface MpxTenantForm {
  name: string;
  description: string;
  did: string;
  api_endpoint: string;
  our_did: string;
  device_token: string;
  enabled: boolean;
  created_at?: string;
  updated_at?: string;
  integrations?: any[];
}

interface OverviewTabProps {
  form: MpxTenantForm;
  setForm: (form: MpxTenantForm) => void;
  isEditMode: boolean;
  saving: boolean;
  id?: string;
  handleSubmit: () => void;
  handleDelete: () => void;
  onNavigate: () => void;
}

const OverviewTab: React.FC<OverviewTabProps> = ({
  form,
  setForm,
  isEditMode,
  saving,
  id,
  handleSubmit,
  handleDelete,
  onNavigate,
}) => {
  const handleInputChange = (field: keyof MpxTenantForm, value: string | boolean) => {
    setForm({ ...form, [field]: value });
  };

  return (
    <div className="tab-pane-content">
      <div className="form-group">
        <label htmlFor="name">
          Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          id="name"
          value={form.name}
          onChange={(e) => handleInputChange('name', e.target.value)}
          required
        />
        <small className="form-text text-muted">
          A friendly name to identify this MPX tenant
        </small>
      </div>

      <div className="form-group">
        <label htmlFor="description">Description</label>
        <input
          className="form-control"
          id="description"          
          value={form.description}
          onChange={(e) => handleInputChange('description', e.target.value)}
        />
        <small className="form-text text-muted">
          Optional description of this MPX tenant
        </small>
      </div>

      {isEditMode && (
        <div className="form-group">
          <label htmlFor="id">Id</label>
          <input
            type="text"
            className="form-control"
            id="id"
            value={id}
            readOnly
            disabled
          />
          <small className="form-text text-muted">
            Unique identifier for this MPX tenant (read-only)
          </small>
        </div>
      )}

      {isEditMode && form.created_at && (
        <div className="form-group">
          <label htmlFor="created_at">Created</label>
          <input
            type="text"
            className="form-control"
            id="created_at"
            value={new Date(form.created_at).toLocaleString()}
            readOnly
            disabled
          />
          <small className="form-text text-muted">
            When this tenant was created
          </small>
        </div>
      )}

      {isEditMode && form.updated_at && (
        <div className="form-group">
          <label htmlFor="updated_at">Last Updated</label>
          <input
            type="text"
            className="form-control"
            id="updated_at"
            value={new Date(form.updated_at).toLocaleString()}
            readOnly
            disabled
          />
          <small className="form-text text-muted">
            When this tenant was last updated
          </small>
        </div>
      )}

      <div className="form-group">
        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input"
            id="enabled"
            checked={form.enabled}
            onChange={(e) => handleInputChange('enabled', e.target.checked)}
          />
          <label className="custom-control-label" htmlFor="enabled">
            Enabled
          </label>
        </div>
        <small className="form-text text-muted">
          When enabled, this tenant can be used for MPX operations
        </small>
      </div>

      {isEditMode && (
        <div className="mt-4 d-flex justify-content-end">
          <button
            className="btn btn-outline-danger mr-2"
            onClick={handleDelete}
            disabled={saving}
          >
            <i className={`fas ${saving ? 'fa-spinner fa-spin' : 'fa-trash'}`}></i>
            {saving ? ' Deleting...' : ' Delete Tenant'}
          </button>
          <button
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={saving}
          >
            <i className={`fas ${saving ? 'fa-spinner fa-spin' : 'fa-save'}`}></i>
            {saving ? ' Saving...' : ' Save Changes'}
          </button>
        </div>
      )}
    </div>
  );
};

export default OverviewTab;
